var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeaderUsers'),_c('main',{staticClass:"card-user"},[_c('div',{staticClass:"user-header"},[_c('h2',[_vm._v(_vm._s(_vm.$t(_vm.$router.currentRoute.meta.usersTitle)))])]),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }